export const LIBRARY_REQUEST_SORT_FIELD = {
  TITLE: "TITLE",
  CREATED: "CREATED_DATE",
  STATUS: "STATUS",
  FILE_NAME: "FILE_NAME",
};
